import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';
import { MicrosoftAccessLinkedService } from '../linkedservice/microsoft-access.linkedservice';


@Metamodel.model({
    name: adfModelTypeMap.microsoftAccess.datasetType,
    display: [stringResources.MicrosoftAccessTable_DisplayText, stringResources.MicrosoftAccessTable_DisplayText],
    constraints: {
        linkedService: {
            model: MicrosoftAccessLinkedService.MODEL // Linked service redefined
        }
    }
})
export class MicrosoftAccessTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
